export default {
  canvas: {
    _skip: 0,
    backgroundColor: "rgba(24, 18, 30, 1)",
    backgroundImage: "",
    backgroundSize: "cover",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "rgba(66, 66, 66, 1)",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    childDelay: 0,
    children: [
      "element_image70b41a10-cd18-11e7-aa95-7b80cd5d096e",
      "element_emptycontainer82b30e40-cd06-11e7-a291-fd3fd9a0ab07",
      "element_emptycontainer50ec25f0-cd0a-11e7-abef-978beb58100b",
      "element_slider15393150-cd10-11e7-9337-23999396b76a"
    ],
    collection: "none",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    gradient: "",
    height: 600,
    hideOverflow: false,
    id: "canvas",
    label: "TwitchIdle",
    leaveAnimation: "none",
    left: 0,
    limit: 10,
    maximum: 100,
    opacity: 1,
    perspective: 150,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 10,
    stayDuration: 7000,
    streamHeight: 9,
    streamWidth: 16,
    top: 0,
    transformOrigin: "50% 50% 0",
    type: "element_emptycontainer",
    width: 600,
    rules: []
  },
  "element_emptycontainer15393151-cd10-11e7-9337-23999396b76a": {
    _skip: 0,
    backgroundColor: "transparent",
    backgroundImage: "",
    backgroundSize: "contain",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#3B4253",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    childDelay: 0,
    children: [
      "element_textcf0b13f0-cd10-11e7-bc1c-7169c2840042",
      "element_textfbea0c00-cd10-11e7-bc1c-7169c2840042",
      "element_emptycontainer417bcce0-cd11-11e7-bc1c-7169c2840042",
      "element_emptycontainer51096dc0-cd11-11e7-bc1c-7169c2840042",
      "element_emptycontainer225d4f70-cd14-11e7-8f59-c946023eef9a",
      "element_emptycontainer25681e70-cd14-11e7-8f59-c946023eef9a"
    ],
    collection: "none",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    gradient: "",
    height: 0.38085539714867617,
    hideOverflow: false,
    id: "element_emptycontainer15393151-cd10-11e7-9337-23999396b76a",
    label: "Slide1-Schedule",
    leaveAnimation: "none",
    left: 0,
    limit: 10,
    locked: true,
    maximum: 100,
    opacity: 1,
    parent: "element_slider15393150-cd10-11e7-9337-23999396b76a",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    stayDuration: 7000,
    top: 0,
    transformOrigin: "50% 50% 0",
    type: "element_emptycontainer",
    width: 0.6812627291242362,
    rules: []
  },
  "element_emptycontainer15395861-cd10-11e7-9337-23999396b76a": {
    _skip: 0,
    backgroundColor: "transparent",
    backgroundImage: "",
    backgroundSize: "contain",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#3B4253",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    childDelay: 0,
    children: [
      "element_text03851c10-cd12-11e7-8f59-c946023eef9a",
      "element_emptycontainer6fcf2000-cd12-11e7-8f59-c946023eef9a",
      "element_emptycontainer939aca70-cd12-11e7-8f59-c946023eef9a",
      "element_emptycontainera83090f0-cd12-11e7-8f59-c946023eef9a"
    ],
    collection: "none",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    gradient: "",
    height: 0.38085539714867617,
    hideOverflow: false,
    id: "element_emptycontainer15395861-cd10-11e7-9337-23999396b76a",
    label: "Slide2-Social",
    leaveAnimation: "none",
    left: 0,
    limit: 10,
    locked: true,
    maximum: 100,
    opacity: 1,
    parent: "element_slider15393150-cd10-11e7-9337-23999396b76a",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    stayDuration: 7000,
    top: 0,
    transformOrigin: "50% 50% 0",
    type: "element_emptycontainer",
    width: 0.6812627291242362,
    rules: []
  },
  "element_emptycontainer1e376a10-d2d3-11e7-8e49-2db7b2d1af7f": {
    _skip: 0,
    backgroundColor: "rgba(152, 75, 67, 0.13)",
    backgroundImage: "",
    backgroundSize: "contain",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#3B4253",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    childDelay: 0,
    children: ["element_text1e379120-d2d3-11e7-8e49-2db7b2d1af7f"],
    collection: "twitch.subs",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    gradient: "",
    height: 0.07433808553971487,
    hideOverflow: false,
    id: "element_emptycontainer1e376a10-d2d3-11e7-8e49-2db7b2d1af7f",
    label: "Subs",
    leaveAnimation: "none",
    left: 0.02181025081788441,
    limit: 3,
    maximum: 100,
    opacity: 1,
    parent: "element_emptycontainerd524bfd0-d2d2-11e7-8e49-2db7b2d1af7f",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    stayDuration: 7000,
    top: 0.10905125408942204,
    transformOrigin: "50% 50% 0",
    type: "element_emptycontainer",
    width: 0.3095723014256619,
    rules: []
  },
  "element_emptycontainer225d4f70-cd14-11e7-8f59-c946023eef9a": {
    _skip: 0,
    backgroundColor: "rgba(152, 75, 67, 0.13)",
    backgroundImage: "",
    backgroundSize: "contain",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#3B4253",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    childDelay: 0,
    children: [
      "element_text225d7680-cd14-11e7-8f59-c946023eef9a",
      "element_text225d9d90-cd14-11e7-8f59-c946023eef9a"
    ],
    collection: "none",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    gradient: "",
    height: 0.07433808553971487,
    hideOverflow: false,
    id: "element_emptycontainer225d4f70-cd14-11e7-8f59-c946023eef9a",
    label: "Tomorrow1",
    leaveAnimation: "none",
    left: 0.3562367864693446,
    limit: 10,
    maximum: 100,
    opacity: 1,
    parent: "element_emptycontainer15393151-cd10-11e7-9337-23999396b76a",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    stayDuration: 7000,
    top: 0.13953488372093018,
    transformOrigin: "50% 50% 0",
    type: "element_emptycontainer",
    width: 0.3065173116089613,
    rules: []
  },
  "element_emptycontainer25681e70-cd14-11e7-8f59-c946023eef9a": {
    _skip: 0,
    backgroundColor: "rgba(152, 75, 67, 0.13)",
    backgroundImage: "",
    backgroundSize: "contain",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#3B4253",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    childDelay: 0,
    children: [
      "element_text25684580-cd14-11e7-8f59-c946023eef9a",
      "element_text25684581-cd14-11e7-8f59-c946023eef9a"
    ],
    collection: "none",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    gradient: "",
    height: 0.07433808553971487,
    hideOverflow: false,
    id: "element_emptycontainer25681e70-cd14-11e7-8f59-c946023eef9a",
    label: "Tomorrow2",
    leaveAnimation: "none",
    left: 0.3562367864693446,
    limit: 10,
    maximum: 100,
    opacity: 1,
    parent: "element_emptycontainer15393151-cd10-11e7-9337-23999396b76a",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    stayDuration: 7000,
    top: 0.23995771670190272,
    transformOrigin: "50% 50% 0",
    type: "element_emptycontainer",
    width: 0.3065173116089613,
    rules: []
  },
  "element_emptycontainer417bcce0-cd11-11e7-bc1c-7169c2840042": {
    _skip: 0,
    backgroundColor: "rgba(152, 75, 67, 0.13)",
    backgroundImage: "",
    backgroundSize: "contain",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#3B4253",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    childDelay: 0,
    children: [
      "element_text458b88c0-cd11-11e7-bc1c-7169c2840042",
      "element_textcc481c00-cd13-11e7-8f59-c946023eef9a"
    ],
    collection: "none",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    gradient: "",
    height: 0.07433808553971487,
    hideOverflow: false,
    id: "element_emptycontainer417bcce0-cd11-11e7-bc1c-7169c2840042",
    label: "Today1",
    leaveAnimation: "none",
    left: 0.017970401691331926,
    limit: 10,
    maximum: 100,
    opacity: 1,
    parent: "element_emptycontainer15393151-cd10-11e7-9337-23999396b76a",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    stayDuration: 7000,
    top: 0.13953488372093018,
    transformOrigin: "50% 50% 0",
    type: "element_emptycontainer",
    width: 0.3095723014256619,
    rules: []
  },
  "element_emptycontainer50ec25f0-cd0a-11e7-abef-978beb58100b": {
    _skip: 0,
    backgroundColor: "transparent",
    backgroundImage: "",
    backgroundSize: "contain",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#3B4253",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    childDelay: 0,
    children: [
      "element_image50ec4d00-cd0a-11e7-abef-978beb58100b",
      "element_emptycontainer50ec4d01-cd0a-11e7-abef-978beb58100b"
    ],
    collection: "none",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    gradient: "",
    height: 0.269857433808554,
    hideOverflow: false,
    id: "element_emptycontainer50ec25f0-cd0a-11e7-abef-978beb58100b",
    label: "Game Box4",
    leaveAnimation: "none",
    left: 0.7579281183932347,
    limit: 10,
    maximum: 100,
    opacity: 1,
    parent: "canvas",
    perspective: 150,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    starter: "element_gamebox",
    stayDuration: 7000,
    top: 0.2972511550401949,
    transformOrigin: "50% 50% 0",
    type: "element_emptycontainer",
    width: 0.2535641547861507,
    rules: []
  },
  "element_emptycontainer50ec4d01-cd0a-11e7-abef-978beb58100b": {
    _skip: 0,
    backgroundColor: "transparent",
    backgroundImage: "{twitch.game_picture}",
    backgroundSize: "cover",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#3B4253",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    childDelay: 0,
    collection: "none",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    gradient: "",
    height: 0.23523421588594703,
    hideOverflow: false,
    id: "element_emptycontainer50ec4d01-cd0a-11e7-abef-978beb58100b",
    label: "Side",
    leaveAnimation: "none",
    left: 0.1807655502392344,
    limit: 10,
    maximum: 100,
    opacity: 1,
    parent: "element_emptycontainer50ec25f0-cd0a-11e7-abef-978beb58100b",
    perspective: 0.21052631578947367,
    rotate: 0,
    rotateX: 0,
    rotateY: 28,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    stayDuration: 7000,
    top: 0.012743800432041685,
    transformOrigin: "50% 50% 0",
    type: "element_emptycontainer",
    width: 0.03360488798370672,
    rules: [],
    children: []
  },
  "element_emptycontainer51096dc0-cd11-11e7-bc1c-7169c2840042": {
    _skip: 0,
    backgroundColor: "rgba(152, 75, 67, 0.13)",
    backgroundImage: "",
    backgroundSize: "contain",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#3B4253",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    childDelay: 0,
    children: [
      "element_text510994d1-cd11-11e7-bc1c-7169c2840042",
      "element_text0a5ebb70-cd14-11e7-8f59-c946023eef9a"
    ],
    collection: "none",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    gradient: "",
    height: 0.07433808553971487,
    hideOverflow: false,
    id: "element_emptycontainer51096dc0-cd11-11e7-bc1c-7169c2840042",
    label: "Today2",
    leaveAnimation: "none",
    left: 0.017970401691331926,
    limit: 10,
    maximum: 100,
    opacity: 1,
    parent: "element_emptycontainer15393151-cd10-11e7-9337-23999396b76a",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    stayDuration: 7000,
    top: 0.23995771670190277,
    transformOrigin: "50% 50% 0",
    type: "element_emptycontainer",
    width: 0.3095723014256619,
    rules: []
  },
  "element_emptycontainer601699a0-f606-11e7-b90d-9bf31856c961": {
    _skip: 0,
    backgroundColor: "rgba(152, 75, 67, 0.13)",
    backgroundImage: "",
    backgroundSize: "contain",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#3B4253",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    childDelay: 0,
    children: [
      "element_text6016c0b0-f606-11e7-b90d-9bf31856c961",
      "element_texta949c430-f606-11e7-b90d-9bf31856c961"
    ],
    collection: "streamlabs.donations",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    gradient: "",
    height: 0.07433808553971487,
    hideOverflow: false,
    id: "element_emptycontainer601699a0-f606-11e7-b90d-9bf31856c961",
    label: "Donatinos",
    leaveAnimation: "none",
    left: 0.3496893120759661,
    limit: 3,
    maximum: 100,
    opacity: 1,
    parent: "element_emptycontainerd524bfd0-d2d2-11e7-8e49-2db7b2d1af7f",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    stayDuration: 7000,
    top: 0.10934182590233546,
    transformOrigin: "50% 50% 0",
    type: "element_emptycontainer",
    width: 0.3095723014256619,
    rules: []
  },
  "element_emptycontainer6fcf2000-cd12-11e7-8f59-c946023eef9a": {
    _skip: 0,
    backgroundColor: "rgba(152, 75, 67, 0.13)",
    backgroundImage: "",
    backgroundSize: "contain",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#3B4253",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    childDelay: 0,
    children: [
      "element_icon72082010-cd12-11e7-8f59-c946023eef9a",
      "element_text77087d80-cd12-11e7-8f59-c946023eef9a"
    ],
    collection: "none",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    gradient: "",
    height: 0.0814663951120163,
    hideOverflow: false,
    id: "element_emptycontainer6fcf2000-cd12-11e7-8f59-c946023eef9a",
    label: "Twitter",
    leaveAnimation: "none",
    left: 0.32452431289640593,
    limit: 10,
    maximum: 100,
    opacity: 1,
    parent: "element_emptycontainer15395861-cd10-11e7-9337-23999396b76a",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    stayDuration: 7000,
    top: 0.030655391120507407,
    transformOrigin: "50% 50% 0",
    type: "element_emptycontainer",
    width: 0.4175152749490835,
    rules: []
  },
  "element_emptycontainer82b30e40-cd06-11e7-a291-fd3fd9a0ab07": {
    _skip: 0,
    backgroundColor: "rgba(152, 75, 67, 1)",
    backgroundImage: "",
    backgroundSize: "contain",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#3B4253",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    childDelay: 0,
    children: ["element_gamename9ad17030-cd0f-11e7-9337-23999396b76a"],
    collection: "none",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    gradient: "",
    height: 0.07128309572301425,
    hideOverflow: false,
    id: "element_emptycontainer82b30e40-cd06-11e7-a291-fd3fd9a0ab07",
    label: "Playing",
    leaveAnimation: "none",
    left: 0,
    limit: 10,
    maximum: 100,
    opacity: 1,
    parent: "canvas",
    perspective: 0.11308805790108564,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.007539203860072376,
    stayDuration: 7000,
    top: 0.4594032413130029,
    transformOrigin: "50% 50% 0",
    type: "element_emptycontainer",
    width: 1,
    rules: []
  },
  "element_emptycontainer939aca70-cd12-11e7-8f59-c946023eef9a": {
    _skip: 0,
    backgroundColor: "rgba(152, 75, 67, 0.13)",
    backgroundImage: "",
    backgroundSize: "contain",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#3B4253",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    childDelay: 0,
    children: [
      "element_icon939b1890-cd12-11e7-8f59-c946023eef9a",
      "element_text939b1891-cd12-11e7-8f59-c946023eef9a"
    ],
    collection: "none",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    gradient: "",
    height: 0.0814663951120163,
    hideOverflow: false,
    id: "element_emptycontainer939aca70-cd12-11e7-8f59-c946023eef9a",
    label: "Facebook",
    leaveAnimation: "none",
    left: 0.32452431289640593,
    limit: 10,
    maximum: 100,
    opacity: 1,
    parent: "element_emptycontainer15395861-cd10-11e7-9337-23999396b76a",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    stayDuration: 7000,
    top: 0.14587737843551798,
    transformOrigin: "50% 50% 0",
    type: "element_emptycontainer",
    width: 0.4175152749490835,
    rules: []
  },
  "element_emptycontainera83090f0-cd12-11e7-8f59-c946023eef9a": {
    _skip: 0,
    backgroundColor: "rgba(152, 75, 67, 0.13)",
    backgroundImage: "",
    backgroundSize: "contain",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#3B4253",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    childDelay: 0,
    children: [
      "element_icona830df10-cd12-11e7-8f59-c946023eef9a",
      "element_texta830df11-cd12-11e7-8f59-c946023eef9a"
    ],
    collection: "none",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    gradient: "",
    height: 0.0814663951120163,
    hideOverflow: false,
    id: "element_emptycontainera83090f0-cd12-11e7-8f59-c946023eef9a",
    label: "Youtube",
    leaveAnimation: "none",
    left: 0.32452431289640593,
    limit: 10,
    maximum: 100,
    opacity: 1,
    parent: "element_emptycontainer15395861-cd10-11e7-9337-23999396b76a",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    stayDuration: 7000,
    top: 0.26215644820295986,
    transformOrigin: "50% 50% 0",
    type: "element_emptycontainer",
    width: 0.4175152749490835,
    rules: []
  },
  "element_emptycontainerd524bfd0-d2d2-11e7-8e49-2db7b2d1af7f": {
    _skip: 0,
    backgroundColor: "element_slider15393150-cd10-11e7-9337-23999396b76a",
    backgroundImage: "",
    backgroundSize: "contain",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#3B4253",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    childDelay: 0,
    children: [
      "element_textf8b0a220-d2d2-11e7-8e49-2db7b2d1af7f",
      "element_text0470c040-d2d3-11e7-8e49-2db7b2d1af7f",
      "element_emptycontainer1e376a10-d2d3-11e7-8e49-2db7b2d1af7f",
      "element_emptycontainer601699a0-f606-11e7-b90d-9bf31856c961"
    ],
    collection: "none",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    gradient: "",
    height: 0.38085539714867617,
    hideOverflow: false,
    id: "element_emptycontainerd524bfd0-d2d2-11e7-8e49-2db7b2d1af7f",
    label: "Thanks",
    leaveAnimation: "none",
    left: 0,
    limit: 10,
    locked: true,
    maximum: 100,
    opacity: 1,
    parent: "element_slider15393150-cd10-11e7-9337-23999396b76a",
    perspective: 0.16357688113413305,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010905125408942205,
    stayDuration: 7000,
    top: 0,
    transformOrigin: "50% 50% 0",
    type: "element_emptycontainer",
    width: 0.6812627291242362,
    rules: []
  },
  "element_gamename9ad17030-cd0f-11e7-9337-23999396b76a": {
    _skip: 0,
    alignItems: "center",
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    color: "rgba(226, 226, 226, 1)",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    fontFamily: "Bungee",
    fontSize: 0.029598308668076112,
    fontStyle: "normal",
    fontWeight: 400,
    height: 0.05285412262156447,
    id: "element_gamename9ad17030-cd0f-11e7-9337-23999396b76a",
    label: "Game Name",
    leaveAnimation: "none",
    left: 0.013742071881606765,
    letterSpacing: 1,
    limit: 10,
    lineHeight: 1.2,
    maxItems: 1,
    maximum: 100,
    minHeight: 20,
    minWidth: 20,
    opacity: 1,
    parent: "element_emptycontainer82b30e40-cd06-11e7-a291-fd3fd9a0ab07",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    stayDuration: 7000,
    text: "Playing {twitch.game} in {countdown.minute}:{countdown.second}",
    textAlign: "center",
    textIdent: 0,
    top: 0.009513742071881607,
    transformOrigin: "50% 50% 0",
    type: "element_gamename",
    width: 0.7621564482029598,
    rules: [],
    children: []
  },
  "element_icon72082010-cd12-11e7-8f59-c946023eef9a": {
    _skip: 0,
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    color: "rgba(152, 75, 67, 1)",
    delay: 0,
    enterAnimation: "none",
    height: 0.04756871035940804,
    icon: "twitter",
    id: "element_icon72082010-cd12-11e7-8f59-c946023eef9a",
    label: "Icon",
    leaveAnimation: "none",
    left: 0.025369978858350947,
    limit: 10,
    lockAspectRatio: true,
    maximum: 100,
    opacity: 1,
    parent: "element_emptycontainer6fcf2000-cd12-11e7-8f59-c946023eef9a",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    stayDuration: 7000,
    top: 0.0200845665961945,
    transformOrigin: "50% 50% 0",
    type: "element_icon",
    width: 0.04756871035940804,
    rules: [],
    children: []
  },
  "element_icon939b1890-cd12-11e7-8f59-c946023eef9a": {
    _skip: 0,
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    color: "rgba(152, 75, 67, 1)",
    delay: 0,
    enterAnimation: "none",
    height: 0.04756871035940804,
    icon: "facebook",
    id: "element_icon939b1890-cd12-11e7-8f59-c946023eef9a",
    label: "Icon",
    leaveAnimation: "none",
    left: 0.025369978858350947,
    limit: 10,
    lockAspectRatio: true,
    maximum: 100,
    opacity: 1,
    parent: "element_emptycontainer939aca70-cd12-11e7-8f59-c946023eef9a",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    stayDuration: 7000,
    top: 0.0200845665961945,
    transformOrigin: "50% 50% 0",
    type: "element_icon",
    width: 0.04756871035940804,
    rules: [],
    children: []
  },
  "element_icona830df10-cd12-11e7-8f59-c946023eef9a": {
    _skip: 0,
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    color: "rgba(152, 75, 67, 1)",
    delay: 0,
    enterAnimation: "none",
    height: 0.04756871035940804,
    icon: "youtube",
    id: "element_icona830df10-cd12-11e7-8f59-c946023eef9a",
    label: "Icon",
    leaveAnimation: "none",
    left: 0.025369978858350947,
    limit: 10,
    lockAspectRatio: true,
    maximum: 100,
    opacity: 1,
    parent: "element_emptycontainera83090f0-cd12-11e7-8f59-c946023eef9a",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    stayDuration: 7000,
    top: 0.016913319238900635,
    transformOrigin: "50% 50% 0",
    type: "element_icon",
    width: 0.04756871035940804,
    rules: [],
    children: []
  },
  "element_image50ec4d00-cd0a-11e7-abef-978beb58100b": {
    _skip: 0,
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    height: 0.21775898520084572,
    id: "element_image50ec4d00-cd0a-11e7-abef-978beb58100b",
    label: "Image",
    leaveAnimation: "none",
    left: 0.02114164904862579,
    limit: 10,
    lockAspectRatio: true,
    maximum: 100,
    opacity: 1,
    parent: "element_emptycontainer50ec25f0-cd0a-11e7-abef-978beb58100b",
    perspective: 0.21052631578947367,
    rotate: 0,
    rotateX: 0,
    rotateY: -17,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    stayDuration: 7000,
    top: 0.02114164904862579,
    transformOrigin: "50% 50% 0",
    type: "element_image",
    url: "{twitch.game_picture}",
    width: 0.15539112050739956,
    rules: [],
    children: []
  },
  "element_image70b41a10-cd18-11e7-aa95-7b80cd5d096e": {
    _skip: 0,
    backgroundColor: "transparent",
    blur: -1,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    height: 0.6666666666666667,
    id: "element_image70b41a10-cd18-11e7-aa95-7b80cd5d096e",
    label: "Background",
    leaveAnimation: "none",
    left: 0,
    limit: 10,
    lockAspectRatio: true,
    maximum: 100,
    opacity: 0.04,
    parent: "canvas",
    perspective: 0.11308805790108564,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 7,
    space: 0.007539203860072376,
    stayDuration: 7000,
    top: 0,
    transformOrigin: "50% 50% 0",
    type: "element_image",
    url:
      "https://images.unsplash.com/photo-1459749411175-04bf5292ceea?auto=format&fit=crop&w=1950&q=60&ixid=dW5zcGxhc2guY29tOzs7Ozs%3D",
    width: 1,
    rules: [],
    children: [],
    locked: true
  },
  "element_slider15393150-cd10-11e7-9337-23999396b76a": {
    _skip: 0,
    backgroundColor: "transparent",
    backgroundImage: "",
    backgroundSize: "contain",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "rgba(152, 75, 67, 1)",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0.0021141649048625794,
    childDelay: 0,
    children: [
      "element_emptycontainer15393151-cd10-11e7-9337-23999396b76a",
      "element_emptycontainer15395861-cd10-11e7-9337-23999396b76a",
      "element_emptycontainerd524bfd0-d2d2-11e7-8e49-2db7b2d1af7f"
    ],
    collection: "none",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    gradient: "",
    height: 0.38085539714867617,
    hideOverflow: false,
    id: "element_slider15393150-cd10-11e7-9337-23999396b76a",
    idleDuration: 10000,
    label: "Slider",
    leaveAnimation: "none",
    left: 0.04817503449225614,
    limit: 10,
    maximum: 100,
    opacity: 1,
    parent: "canvas",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    slide: 3,
    slidingDuration: 600,
    space: 0.010570824524312895,
    stayDuration: 7000,
    top: 0.0374645832748899,
    transformOrigin: "50% 50% 0",
    transition: "Fade",
    type: "element_slider",
    width: 0.6812627291242362,
    rules: []
  },
  "element_text03851c10-cd12-11e7-8f59-c946023eef9a": {
    _skip: 0,
    alignItems: "center",
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    color: "rgba(226, 226, 226, 1)",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    fontFamily: "Roboto",
    fontSize: 0.03171247357293869,
    fontStyle: "normal",
    fontWeight: 400,
    height: 0.16384778012684986,
    id: "element_text03851c10-cd12-11e7-8f59-c946023eef9a",
    label: "Text",
    leaveAnimation: "none",
    left: 0.07505285412262157,
    letterSpacing: 2,
    limit: 10,
    lineHeight: 1.7,
    maxItems: 1,
    maximum: 100,
    minHeight: 20,
    minWidth: 20,
    opacity: 1,
    parent: "element_emptycontainer15395861-cd10-11e7-9337-23999396b76a",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    stayDuration: 7000,
    text: "STAY UP TO DATE",
    textAlign: "left",
    textIdent: 0,
    top: 0.10570824524312894,
    transformOrigin: "50% 50% 0",
    type: "element_text",
    width: 0.16173361522198734,
    rules: [],
    children: []
  },
  "element_text0470c040-d2d3-11e7-8e49-2db7b2d1af7f": {
    _skip: 0,
    alignItems: "center",
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    color: "rgba(226, 226, 226, 1)",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    fontFamily: "Bungee",
    fontSize: 0.03171247357293869,
    fontStyle: "normal",
    fontWeight: 400,
    height: 0.04786150712830957,
    id: "element_text0470c040-d2d3-11e7-8e49-2db7b2d1af7f",
    label: "DonaTitle",
    leaveAnimation: "none",
    left: 0.3527108618846942,
    letterSpacing: 0,
    limit: 10,
    lineHeight: 1.2,
    maxItems: 1,
    maximum: 100,
    minHeight: 20,
    minWidth: 20,
    opacity: 1,
    parent: "element_emptycontainerd524bfd0-d2d2-11e7-8e49-2db7b2d1af7f",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    stayDuration: 7000,
    text: "Donations",
    textAlign: "center",
    textIdent: 0,
    top: 0.02181025081788441,
    transformOrigin: "50% 50% 0",
    type: "element_text",
    width: 0.3044806517311609,
    rules: [],
    children: []
  },
  "element_text0a5ebb70-cd14-11e7-8f59-c946023eef9a": {
    _skip: 0,
    alignItems: "center",
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    color: "rgba(152, 75, 67, 1)",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    fontFamily: "Roboto",
    fontSize: 0.03171247357293869,
    fontStyle: "normal",
    fontWeight: 400,
    height: 0.07399577167019027,
    id: "element_text0a5ebb70-cd14-11e7-8f59-c946023eef9a",
    label: "Text",
    leaveAnimation: "none",
    left: 0.0200845665961945,
    letterSpacing: 0,
    limit: 10,
    lineHeight: 1.2,
    maxItems: 1,
    maximum: 100,
    minHeight: 20,
    minWidth: 20,
    opacity: 1,
    parent: "element_emptycontainer51096dc0-cd11-11e7-bc1c-7169c2840042",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    stayDuration: 7000,
    text: "6pm",
    textAlign: "left",
    textIdent: 0,
    top: 0,
    transformOrigin: "50% 50% 0",
    type: "element_text",
    width: 0.06553911205073996,
    rules: [],
    children: []
  },
  "element_text1e379120-d2d3-11e7-8e49-2db7b2d1af7f": {
    _skip: 0,
    alignItems: "center",
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "",
    color: "rgba(226, 226, 226, 1)",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    fontFamily: "Roboto",
    fontSize: 0.03171247357293869,
    fontStyle: "normal",
    fontWeight: 400,
    height: 0.07433808553971487,
    id: "element_text1e379120-d2d3-11e7-8e49-2db7b2d1af7f",
    label: "Text",
    leaveAnimation: "none",
    left: 0,
    letterSpacing: 0,
    limit: 10,
    lineHeight: 1.2,
    maxItems: 1,
    maximum: 100,
    minHeight: 20,
    minWidth: 20,
    opacity: 1,
    parent: "element_emptycontainer1e376a10-d2d3-11e7-8e49-2db7b2d1af7f",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    stayDuration: 7000,
    text: "{twitch.subs.user}",
    textAlign: "center",
    textIdent: 0,
    top: 0,
    transformOrigin: "50% 50% 0",
    type: "element_text",
    width: 0.3095723014256619,
    rules: [],
    children: []
  },
  "element_text225d7680-cd14-11e7-8f59-c946023eef9a": {
    _skip: 0,
    alignItems: "center",
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    color: "rgba(226, 226, 226, 1)",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    fontFamily: "Roboto",
    fontSize: 0.03171247357293869,
    fontStyle: "normal",
    fontWeight: 400,
    height: 0.07399577167019027,
    id: "element_text225d7680-cd14-11e7-8f59-c946023eef9a",
    label: "Text",
    leaveAnimation: "none",
    left: 0.11099365750528542,
    letterSpacing: 0,
    limit: 10,
    lineHeight: 1.2,
    maxItems: 1,
    maximum: 100,
    minHeight: 20,
    minWidth: 20,
    opacity: 1,
    parent: "element_emptycontainer225d4f70-cd14-11e7-8f59-c946023eef9a",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    stayDuration: 7000,
    text: "PUBG",
    textAlign: "left",
    textIdent: 0,
    top: 0,
    transformOrigin: "50% 50% 0",
    type: "element_text",
    width: 0.19556025369978858,
    rules: [],
    children: []
  },
  "element_text225d9d90-cd14-11e7-8f59-c946023eef9a": {
    _skip: 0,
    alignItems: "center",
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    color: "rgba(152, 75, 67, 1)",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    fontFamily: "Roboto",
    fontSize: 0.03171247357293869,
    fontStyle: "normal",
    fontWeight: 400,
    height: 0.048625792811839326,
    id: "element_text225d9d90-cd14-11e7-8f59-c946023eef9a",
    label: "Text",
    leaveAnimation: "none",
    left: 0.02114164904862579,
    letterSpacing: 0,
    limit: 10,
    lineHeight: 1.2,
    maxItems: 1,
    maximum: 100,
    minHeight: 20,
    minWidth: 20,
    opacity: 1,
    parent: "element_emptycontainer225d4f70-cd14-11e7-8f59-c946023eef9a",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    stayDuration: 7000,
    text: "4pm",
    textAlign: "left",
    textIdent: 0,
    top: 0.012684989429175474,
    transformOrigin: "50% 50% 0",
    type: "element_text",
    width: 0.04334038054968287,
    rules: [],
    children: []
  },
  "element_text25684580-cd14-11e7-8f59-c946023eef9a": {
    _skip: 0,
    alignItems: "center",
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    color: "rgba(226, 226, 226, 1)",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    fontFamily: "Roboto",
    fontSize: 0.03171247357293869,
    fontStyle: "normal",
    fontWeight: 400,
    height: 0.07399577167019027,
    id: "element_text25684580-cd14-11e7-8f59-c946023eef9a",
    label: "Text",
    leaveAnimation: "none",
    left: 0.11099365750528542,
    letterSpacing: 0,
    limit: 10,
    lineHeight: 1.2,
    maxItems: 1,
    maximum: 100,
    minHeight: 20,
    minWidth: 20,
    opacity: 1,
    parent: "element_emptycontainer25681e70-cd14-11e7-8f59-c946023eef9a",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    stayDuration: 7000,
    text: "You decide",
    textAlign: "left",
    textIdent: 0,
    top: 0,
    transformOrigin: "50% 50% 0",
    type: "element_text",
    width: 0.19556025369978858,
    rules: [],
    children: []
  },
  "element_text25684581-cd14-11e7-8f59-c946023eef9a": {
    _skip: 0,
    alignItems: "center",
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    color: "rgba(152, 75, 67, 1)",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    fontFamily: "Roboto",
    fontSize: 0.03171247357293869,
    fontStyle: "normal",
    fontWeight: 400,
    height: 0.048625792811839326,
    id: "element_text25684581-cd14-11e7-8f59-c946023eef9a",
    label: "Text",
    leaveAnimation: "none",
    left: 0.02114164904862579,
    letterSpacing: 0,
    limit: 10,
    lineHeight: 1.2,
    maxItems: 1,
    maximum: 100,
    minHeight: 20,
    minWidth: 20,
    opacity: 1,
    parent: "element_emptycontainer25681e70-cd14-11e7-8f59-c946023eef9a",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    stayDuration: 7000,
    text: "8pm",
    textAlign: "left",
    textIdent: 0,
    top: 0.012684989429175474,
    transformOrigin: "50% 50% 0",
    type: "element_text",
    width: 0.04334038054968287,
    rules: [],
    children: []
  },
  "element_text458b88c0-cd11-11e7-bc1c-7169c2840042": {
    _skip: 0,
    alignItems: "center",
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    color: "rgba(226, 226, 226, 1)",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    fontFamily: "Roboto",
    fontSize: 0.03171247357293869,
    fontStyle: "normal",
    fontWeight: 400,
    height: 0.07399577167019027,
    id: "element_text458b88c0-cd11-11e7-bc1c-7169c2840042",
    label: "Text",
    leaveAnimation: "none",
    left: 0.13530655391120508,
    letterSpacing: 0,
    limit: 10,
    lineHeight: 1.2,
    maxItems: 1,
    maximum: 100,
    minHeight: 20,
    minWidth: 20,
    opacity: 1,
    parent: "element_emptycontainer417bcce0-cd11-11e7-bc1c-7169c2840042",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    stayDuration: 7000,
    text: "League",
    textAlign: "left",
    textIdent: 0,
    top: 0,
    transformOrigin: "50% 50% 0",
    type: "element_text",
    width: 0.19873150105708245,
    rules: [],
    children: []
  },
  "element_text510994d1-cd11-11e7-bc1c-7169c2840042": {
    _skip: 0,
    alignItems: "center",
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    color: "rgba(226, 226, 226, 1)",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    fontFamily: "Roboto",
    fontSize: 0.03171247357293869,
    fontStyle: "normal",
    fontWeight: 400,
    height: 0.07399577167019027,
    id: "element_text510994d1-cd11-11e7-bc1c-7169c2840042",
    label: "Text",
    leaveAnimation: "none",
    left: 0.13530655391120508,
    letterSpacing: 0,
    limit: 10,
    lineHeight: 1.2,
    maxItems: 1,
    maximum: 100,
    minHeight: 20,
    minWidth: 20,
    opacity: 1,
    parent: "element_emptycontainer51096dc0-cd11-11e7-bc1c-7169c2840042",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    stayDuration: 7000,
    text: "Fornite",
    textAlign: "left",
    textIdent: 0,
    top: 0,
    transformOrigin: "50% 50% 0",
    type: "element_text",
    width: 0.17230443974630025,
    rules: [],
    children: []
  },
  "element_text6016c0b0-f606-11e7-b90d-9bf31856c961": {
    _skip: 0,
    alignItems: "center",
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    color: "rgba(226, 226, 226, 1)",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    fontFamily: "Roboto",
    fontSize: 0.03171247357293869,
    fontStyle: "normal",
    fontWeight: 400,
    height: 0.07433808553971487,
    id: "element_text6016c0b0-f606-11e7-b90d-9bf31856c961",
    label: "Name",
    leaveAnimation: "none",
    left: 0.018046709129511677,
    letterSpacing: 0,
    limit: 10,
    lineHeight: 1.2,
    maxItems: 1,
    maximum: 100,
    minHeight: 20,
    minWidth: 20,
    opacity: 1,
    parent: "element_emptycontainer601699a0-f606-11e7-b90d-9bf31856c961",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    stayDuration: 7000,
    text: "{streamlabs.donations.name}",
    textAlign: "center",
    textIdent: 0,
    top: 0,
    transformOrigin: "50% 50% 0",
    type: "element_text",
    width: 0.1985743380855397,
    rules: [],
    children: []
  },
  "element_text77087d80-cd12-11e7-8f59-c946023eef9a": {
    _skip: 0,
    alignItems: "center",
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    color: "rgba(226, 226, 226, 1)",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    fontFamily: "Roboto",
    fontSize: 0.02748414376321353,
    fontStyle: "normal",
    fontWeight: 400,
    height: 0.08139534883720934,
    id: "element_text77087d80-cd12-11e7-8f59-c946023eef9a",
    label: "Text",
    leaveAnimation: "none",
    left: 0.09619450317124736,
    letterSpacing: 0,
    limit: 10,
    lineHeight: 1.2,
    maxItems: 1,
    maximum: 100,
    minHeight: 20,
    minWidth: 20,
    opacity: 1,
    parent: "element_emptycontainer6fcf2000-cd12-11e7-8f59-c946023eef9a",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    stayDuration: 7000,
    text: "twitter",
    textAlign: "left",
    textIdent: 0,
    top: 0,
    transformOrigin: "50% 50% 0",
    type: "element_text",
    width: 0.10042283298097254,
    rules: [],
    children: []
  },
  "element_text939b1891-cd12-11e7-8f59-c946023eef9a": {
    _skip: 0,
    alignItems: "center",
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    color: "rgba(226, 226, 226, 1)",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    fontFamily: "Roboto",
    fontSize: 0.02748414376321353,
    fontStyle: "normal",
    fontWeight: 400,
    height: 0.08139534883720934,
    id: "element_text939b1891-cd12-11e7-8f59-c946023eef9a",
    label: "Text",
    leaveAnimation: "none",
    left: 0.09619450317124736,
    letterSpacing: 0,
    limit: 10,
    lineHeight: 1.2,
    maxItems: 1,
    maximum: 100,
    minHeight: 20,
    minWidth: 20,
    opacity: 1,
    parent: "element_emptycontainer939aca70-cd12-11e7-8f59-c946023eef9a",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    stayDuration: 7000,
    text: "facebook",
    textAlign: "left",
    textIdent: 0,
    top: 0,
    transformOrigin: "50% 50% 0",
    type: "element_text",
    width: 0.1437632135306554,
    rules: [],
    children: []
  },
  "element_texta830df11-cd12-11e7-8f59-c946023eef9a": {
    _skip: 0,
    alignItems: "center",
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    color: "rgba(226, 226, 226, 1)",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    fontFamily: "Roboto",
    fontSize: 0.02748414376321353,
    fontStyle: "normal",
    fontWeight: 400,
    height: 0.08139534883720934,
    id: "element_texta830df11-cd12-11e7-8f59-c946023eef9a",
    label: "Text",
    leaveAnimation: "none",
    left: 0.09619450317124736,
    letterSpacing: 0,
    limit: 10,
    lineHeight: 1.2,
    maxItems: 1,
    maximum: 100,
    minHeight: 20,
    minWidth: 20,
    opacity: 1,
    parent: "element_emptycontainera83090f0-cd12-11e7-8f59-c946023eef9a",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    stayDuration: 7000,
    text: "youtube",
    textAlign: "left",
    textIdent: 0,
    top: 0,
    transformOrigin: "50% 50% 0",
    type: "element_text",
    width: 0.1437632135306554,
    rules: [],
    children: []
  },
  "element_texta949c430-f606-11e7-b90d-9bf31856c961": {
    _skip: 0,
    alignItems: "center",
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    color: "rgba(152, 75, 67, 1)",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    fontFamily: "Roboto",
    fontSize: 0.03171247357293869,
    fontStyle: "normal",
    fontWeight: 400,
    height: 0.07433808553971487,
    id: "element_texta949c430-f606-11e7-b90d-9bf31856c961",
    label: "Amount",
    leaveAnimation: "none",
    left: 0.22895343356640335,
    letterSpacing: 0,
    limit: 10,
    lineHeight: 1.2,
    maxItems: 1,
    maximum: 100,
    minHeight: 20,
    minWidth: 20,
    opacity: 1,
    parent: "element_emptycontainer601699a0-f606-11e7-b90d-9bf31856c961",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    stayDuration: 7000,
    text: "{streamlabs.donations.amount}$",
    textAlign: "right",
    textIdent: 0,
    top: 0,
    transformOrigin: "50% 50% 0",
    type: "element_text",
    width: 0.07026476578411406,
    rules: [],
    children: []
  },
  "element_textae700141-cd16-11e7-aa95-7b80cd5d096e": {
    _skip: 0,
    alignItems: "center",
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    color: "#444",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    fontFamily: "Times New Roman",
    fontSize: 0.022617611580217127,
    fontStyle: "normal",
    fontWeight: 400,
    height: 0.060313630880579006,
    id: "element_textae700141-cd16-11e7-aa95-7b80cd5d096e",
    label: "Text",
    leaveAnimation: "none",
    left: 0.11308805790108564,
    letterSpacing: 0,
    limit: 10,
    lineHeight: 1.2,
    maxItems: 1,
    maximum: 100,
    minHeight: 20,
    minWidth: 20,
    opacity: 1,
    parent: "element_emptycontainerae700140-cd16-11e7-aa95-7b80cd5d096e",
    perspective: 0.11308805790108564,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.007539203860072376,
    stayDuration: 7000,
    text: "Slide 1",
    textAlign: "center",
    textIdent: 0,
    top: 0.08293124246079614,
    transformOrigin: "50% 50% 0",
    type: "element_text",
    width: 0.07539203860072376,
    rules: [],
    children: []
  },
  "element_textae700143-cd16-11e7-aa95-7b80cd5d096e": {
    _skip: 0,
    alignItems: "center",
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    color: "#444",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    fontFamily: "Times New Roman",
    fontSize: 0.022617611580217127,
    fontStyle: "normal",
    fontWeight: 400,
    height: 0.060313630880579006,
    id: "element_textae700143-cd16-11e7-aa95-7b80cd5d096e",
    label: "Text",
    leaveAnimation: "none",
    left: 0.11308805790108564,
    letterSpacing: 0,
    limit: 10,
    lineHeight: 1.2,
    maxItems: 1,
    maximum: 100,
    minHeight: 20,
    minWidth: 20,
    opacity: 1,
    parent: "element_emptycontainerae700142-cd16-11e7-aa95-7b80cd5d096e",
    perspective: 0.11308805790108564,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.007539203860072376,
    stayDuration: 7000,
    text: "Slide 2",
    textAlign: "center",
    textIdent: 0,
    top: 0.08293124246079614,
    transformOrigin: "50% 50% 0",
    type: "element_text",
    width: 0.07539203860072376,
    rules: [],
    children: []
  },
  "element_textcc481c00-cd13-11e7-8f59-c946023eef9a": {
    _skip: 0,
    alignItems: "center",
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    color: "rgba(152, 75, 67, 1)",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    fontFamily: "Roboto",
    fontSize: 0.03171247357293869,
    fontStyle: "normal",
    fontWeight: 400,
    height: 0.048625792811839326,
    id: "element_textcc481c00-cd13-11e7-8f59-c946023eef9a",
    label: "Text",
    leaveAnimation: "none",
    left: 0.02114164904862579,
    letterSpacing: 0,
    limit: 10,
    lineHeight: 1.2,
    maxItems: 1,
    maximum: 100,
    minHeight: 20,
    minWidth: 20,
    opacity: 1,
    parent: "element_emptycontainer417bcce0-cd11-11e7-bc1c-7169c2840042",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    stayDuration: 7000,
    text: "2pm",
    textAlign: "left",
    textIdent: 0,
    top: 0.012684989429175474,
    transformOrigin: "50% 50% 0",
    type: "element_text",
    width: 0.04334038054968287,
    rules: [],
    children: []
  },
  "element_textcf0b13f0-cd10-11e7-bc1c-7169c2840042": {
    _skip: 0,
    alignItems: "center",
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    color: "rgba(226, 226, 226, 1)",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    fontFamily: "Bungee",
    fontSize: 0.03171247357293869,
    fontStyle: "normal",
    fontWeight: 400,
    height: 0.04786150712830957,
    id: "element_textcf0b13f0-cd10-11e7-bc1c-7169c2840042",
    label: "Today",
    leaveAnimation: "none",
    left: 0.015856236786469347,
    letterSpacing: 0,
    limit: 10,
    lineHeight: 1.2,
    maxItems: 1,
    maximum: 100,
    minHeight: 20,
    minWidth: 20,
    opacity: 1,
    parent: "element_emptycontainer15393151-cd10-11e7-9337-23999396b76a",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    stayDuration: 7000,
    text: "Today",
    textAlign: "center",
    textIdent: 0,
    top: 0.035940803382663866,
    transformOrigin: "50% 50% 0",
    type: "element_text",
    width: 0.3044806517311609,
    rules: [],
    children: []
  },
  "element_textf8b0a220-d2d2-11e7-8e49-2db7b2d1af7f": {
    _skip: 0,
    alignItems: "center",
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    color: "rgba(226, 226, 226, 1)",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    fontFamily: "Bungee",
    fontSize: 0.03171247357293869,
    fontStyle: "normal",
    fontWeight: 400,
    height: 0.04786150712830957,
    id: "element_textf8b0a220-d2d2-11e7-8e49-2db7b2d1af7f",
    label: "SubsTitle",
    leaveAnimation: "none",
    left: 0.02181025081788441,
    letterSpacing: 0,
    limit: 10,
    lineHeight: 1.2,
    maxItems: 1,
    maximum: 100,
    minHeight: 20,
    minWidth: 20,
    opacity: 1,
    parent: "element_emptycontainerd524bfd0-d2d2-11e7-8e49-2db7b2d1af7f",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    stayDuration: 7000,
    text: "Subs",
    textAlign: "center",
    textIdent: 0,
    top: 0.02181025081788441,
    transformOrigin: "50% 50% 0",
    type: "element_text",
    width: 0.3044806517311609,
    rules: [],
    children: []
  },
  "element_textfbea0c00-cd10-11e7-bc1c-7169c2840042": {
    _skip: 0,
    alignItems: "center",
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    color: "rgba(226, 226, 226, 1)",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    fontFamily: "Bungee",
    fontSize: 0.03171247357293869,
    fontStyle: "normal",
    fontWeight: 400,
    height: 0.04786150712830957,
    id: "element_textfbea0c00-cd10-11e7-bc1c-7169c2840042",
    label: "Tomorrow",
    leaveAnimation: "none",
    left: 0.3562367864693446,
    letterSpacing: 0,
    limit: 10,
    lineHeight: 1.2,
    maxItems: 1,
    maximum: 100,
    minHeight: 20,
    minWidth: 20,
    opacity: 1,
    parent: "element_emptycontainer15393151-cd10-11e7-9337-23999396b76a",
    perspective: 0.15856236786469344,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.010570824524312895,
    stayDuration: 7000,
    text: "Tomorrow",
    textAlign: "center",
    textIdent: 0,
    top: 0.03594080338266385,
    transformOrigin: "50% 50% 0",
    type: "element_text",
    width: 0.2973523421588595,
    rules: [],
    children: []
  }
};



// WEBPACK FOOTER //
// ./src/constants/templates/idle.js